import React, { useState } from 'react';
import { ActivityRendererProps } from './types';

const GameActivity: React.FC<ActivityRendererProps> = ({ activity, onComplete }) => {
  const [gameCompleted, setGameCompleted] = useState(false);
  const [score, setScore] = useState(0);

  const handleGameComplete = (gameScore: number) => {
    setScore(gameScore);
    setGameCompleted(true);
    onComplete(gameScore);
  };

  return (
    <div className="game-activity">
      <div className="game-content">
        <h3>Word Matching Game</h3>
        <p>Match the Chinese words with their English meanings.</p>
        
        <div className="game-placeholder">
          <p>Game implementation coming soon...</p>
          <button 
            className="complete-btn"
            onClick={() => handleGameComplete(85)}
          >
            Simulate Game Complete (85%)
          </button>
        </div>
      </div>
    </div>
  );
};

export default GameActivity;

